/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { PersonRefreshSummaryPathParams, PersonRefreshSummaryResponse } from '../types/PersonRefreshSummary'

/**
 * POST /organisations/:organisationId/persons/:person/refresh-summary
 * @see backend/nexus/modules/Campaign/Http/Controllers/PersonController.php PersonController::refreshSummary
 */
export async function personRefreshSummary(
	organisationId: PersonRefreshSummaryPathParams['organisationId'],
	person: PersonRefreshSummaryPathParams['person'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PersonRefreshSummaryResponse>> {
	return axiosInstance.post(`/organisations/${organisationId}/persons/${person}/refresh-summary`, undefined, config)
}
